import { apiClient } from '../../client'
import endpoints from '../../endpoints'
import { unwrapSingle } from '../../normalize'
import { QUHintsResponse } from '../../../../types/apiModels'

export default async function getHints({
  farmId,
  year,
  signal,
}: {
  farmId: string
  year?: string
  signal?: AbortSignal
}): Promise<QUHintsResponse> {
  const response = await apiClient.get(endpoints.v2.quantificationUnits.hints, {
    // The endpoint answers 400 on an invalid year, so an absent one is omitted rather than sent.
    params: year ? { farmId, year } : { farmId },
    signal,
  })
  return unwrapSingle<QUHintsResponse>(response)
}
